// extracted by mini-css-extract-plugin
module.exports = {"desktop":"ResponsiveImage_desktop__dRuhP","mobile":"ResponsiveImage_mobile__BBBwh"};